import { useQuery } from '@tanstack/react-query';

import { catalogService } from '../services/catalog.service';

/**
 * Recupera la lista de todos los catálogos definidos en el sistema
 *
 * @return {*} Lista de catálogos definidos en el sistema
 */
export const useCatalogList = () => {
  return useQuery({
    queryKey: ['listCatalogs'],
    queryFn: () => catalogService.listCatalogs()
  });
};
